/*eslint-disable*/
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import { setLayout, useMaterialUIController } from "../context";
import DefaultNavbar from "../components/Navbars/DefaultNavbar";
import PricingPage from "./pages/pricing-page";
import {useMeQuery} from "../store/api/auth";

export default function Index() {
    const { data: user } = useMeQuery();
    const [controller, dispatch] = useMaterialUIController();
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "index");
    }, [pathname]);
    return (
        <>
        <PricingPage/>
        </>
    );
}
